<template>
  <div class="asc-note--container">
    <span class="asc-note"><slot></slot></span>
  </div>
</template>

<script>
export default {
  name: 'AscNote',
}
</script>

<style lang="scss">
.asc-note--container {
  background-color: $gray-700;
  padding: 8px;
}

.asc-note {
  color: $primary-white;
}
</style>
